<script setup lang="js">
const props = defineProps({
  color: ''
})
</script>

<template>
  <div class="pt-5" :class="color">
    <div class="container mx-auto py-[1.5rem] px-5">
      <slot></slot>
    </div>
  </div>
</template>

<style scoped>

</style>
